import { render } from "./h5.vue?vue&type=template&id=afacde1a&scoped=true"
import script from "./h5.vue?vue&type=script&lang=js"
export * from "./h5.vue?vue&type=script&lang=js"

import "./h5.vue?vue&type=style&index=0&id=afacde1a&scoped=scoped&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afacde1a"]])

export default __exports__